import { render } from "./RuiLocation.vue?vue&type=template&id=48d2d108"
const script = {}
script.render = render

export default script